import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import AndroidIcon from '@material-ui/icons/Android';
import MenuBookOutlinedIcon from '@material-ui/icons/MenuBookOutlined';

const agentContent = EntityContentBlueprint.make({
  name: 'clrslate-agent',
  params: {
    path: 'agent',
    title: 'Agent',
    group: 'overview',
    icon: <AndroidIcon />,
    filter: entity => entity?.kind.toLocaleLowerCase('en-US') === 'agent',
    loader: async () => {
      const { AgentEntityPage } = await import('./AgentEntityPage');
      return <AgentEntityPage />;
    },
  },
});

const knowledgeContent = EntityContentBlueprint.make({
  name: 'clrslate-reliability-knowledge',
  params: {
    path: 'knowledge',
    title: 'Approved artifact',
    group: 'documentation',
    icon: <MenuBookOutlinedIcon />,
    filter: entity =>
      entity?.kind.toLocaleLowerCase('en-US') === 'resource' &&
      (entity.spec?.type === 'rca' || entity.spec?.type === 'runbook'),
    loader: async () => {
      const { KnowledgeEntityPage } = await import('./KnowledgeEntityPage');
      return <KnowledgeEntityPage />;
    },
  },
});

export const reliabilityDiscoveryModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [agentContent, knowledgeContent],
});
